'use client';

import { useEffect } from 'react';

export default function CloseScreen() {
  useEffect(() => {
    window.close();
  }, []);

  return null;
}
